export default function JambonzProviderIcon() {
  return (
    <svg viewBox='0 0 24 24' className='w-6 h-6' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect width='24' height='24' rx='4' fill='#FF6B35' />
      <path d='M12 6L8 10H11V18H13V10H16L12 6Z' fill='white' />
    </svg>
  );
}
